var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.getTextRows),function(text){return (_vm.tag=='p')?_c('p',[_vm._v(" "+_vm._s(text)+" ")]):_vm._e()}),0)}
var staticRenderFns = []

export { render, staticRenderFns }